import React, { Component } from 'react'
    
class Puppies extends Component {
    componentDidMount() {
        window.location.replace("https://calendar.app.google/xWCq4BLZEr7cbSjB8");
    }

    render() {
        return <div />
    }
}

export default Puppies



